import NumberExtension from '80.quickConnect.Core/formatting/NumberExtension';
import { isActionData } from '90.quickConnect.Models/guards';
import { QCActionData } from '90.quickConnect.Models/models';

export default function mapAllFieldTypeValuesToNumeric(value: unknown): number | null | undefined {
  if (value === null || value === '') return null;

  if (value === undefined) return undefined;

  if (isActionData(value) && value.length > 0) {
    const [firstAction] = value as QCActionData;
    const { value: actionDataValue } = firstAction;

    return mapAllFieldTypeValuesToNumeric(actionDataValue);
  }

  const double = NumberExtension.createDoubleValue(value);

  if (!NumberExtension.isAValidNumber(double)) return undefined;

  return double;
}
